import { ImageSearchResultCard } from '@monash/portal-frontend-common';
import { getPrimaryUrl } from './utils';
import { resolveCategoryNames } from './resolve-category-names';

export const ImageTileAdapter = ({ entity, allCategories, className }) => {
  const { linkType, name, description, displayLabel, categories, image } =
    entity ?? {};

  return (
    <ImageSearchResultCard
      linkType={linkType}
      name={name}
      description={description}
      displayLabel={displayLabel}
      categoryNames={resolveCategoryNames(categories, allCategories)}
      url={getPrimaryUrl(entity)}
      imageUrl={image?.url}
      className={className}
    />
  );
};
